import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { DEFAULT_FILL_OPACITY, ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const DocumentCenterIcon: React.FC<IconProps> = ({
  viewBox = ICON_VIEWBOX.medium,
  color = 'currentColor',
  size = ICON_SIZE.medium,
  isFilled,
  fillOpacity = DEFAULT_FILL_OPACITY,
}) => {
  const path = isFilled ? (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.436 2.529C3.726 2.203 4.14 2 4.594 2h14.812c.454 0 .868.203 1.158.529.288.322.436.742.436 1.163v16.616c0 .421-.148.841-.436 1.163-.29.326-.704.529-1.158.529H4.594c-.454 0-.868-.203-1.158-.529A1.75 1.75 0 0 1 3 20.308V3.692c0-.421.148-.841.436-1.163zm2.65 5.368a.77.77 0 0 1 .771-.769h10.286a.77.77 0 1 1 0 1.539H6.857a.77.77 0 0 1-.771-.77zm0 4.103a.77.77 0 0 1 .771-.77h10.286a.77.77 0 1 1 0 1.54H6.857a.77.77 0 0 1-.771-.77zm0 4.103a.77.77 0 0 1 .771-.77H12a.77.77 0 1 1 0 1.539H6.857a.77.77 0 0 1-.771-.77z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  ) : (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.436 2.529C3.726 2.203 4.14 2 4.594 2h14.812c.454 0 .868.203 1.158.529.288.322.436.742.436 1.163v16.616c0 .421-.148.841-.436 1.163-.29.326-.704.529-1.158.529H4.594c-.454 0-.868-.203-1.158-.529A1.75 1.75 0 0 1 3 20.308V3.692c0-.421.148-.841.436-1.163zm1.166 1.01a.075.075 0 0 0-.013.012.218.218 0 0 0-.046.141v16.616c0 .068.025.118.046.141.006.007.01.01.013.012h14.796a.073.073 0 0 0 .013-.012.218.218 0 0 0 .046-.141V3.692a.218.218 0 0 0-.046-.141.075.075 0 0 0-.013-.013H4.602zm1.484 4.358a.77.77 0 0 1 .771-.769h10.286a.77.77 0 1 1 0 1.539H6.857a.77.77 0 0 1-.771-.77zm0 4.103a.77.77 0 0 1 .771-.77h10.286a.77.77 0 1 1 0 1.54H6.857a.77.77 0 0 1-.771-.77zm0 4.103a.77.77 0 0 1 .771-.77H12a.77.77 0 1 1 0 1.539H6.857a.77.77 0 0 1-.771-.77z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  )

  return (
    <SvgWrapper viewBox={viewBox} size={size}>
      {path}
    </SvgWrapper>
  )
}

export default DocumentCenterIcon
